import React, { Component, Fragment } from 'react';
import { canUseDOM } from 'exenv';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import formatPostObject from '../../../utils/format_post_object';
import Ad from '../ad/ad';
import Card from '../card/card';
import Scroll from '../scroll/scroll';
import Social from '../social/social';
import NewsletterSignup from '../newsletters/newsletter-signup';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import asyncPostNativeAdActions from '../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../redux/action_creators/ads_action_creator';

class FeatureFeed extends Component {
  constructor(props) {
    super(props);
    this.getFeaturedStory = this.getFeaturedStory.bind(this);
    this.buildActiveSponsoredCardDataObject = this.buildActiveSponsoredCardDataObject.bind(
      this
    );
    this.getFeaturedStory = this.getFeaturedStory.bind(this);
    this.getSponsoredCardDataFromNativePixel = this.getSponsoredCardDataFromNativePixel.bind(
      this
    );
    this.getScrollingModule = this.getScrollingModule.bind(this);
    this.renderSponsoredCard = this.renderSponsoredCard.bind(this);
    this.state = {
      sponsoredCardData: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const nativeAdHomepageTileLoaded = get(
      nextProps,
      'adsLoaded.native_homepagefeature'
    );

    if (nativeAdHomepageTileLoaded) {
      this.getSponsoredCardDataFromNativePixel();
      this.props.dispatchAdLoadedEvent('native_homepagefeature', false);
    }

    const newPostNativeAd = get(
      nextProps,
      'postNativeAd.homepageFeaturedTile.posts'
    );

    if (
      get(newPostNativeAd, 'length') !==
        get(this.props, 'postNativeAd.homepageFeaturedTile.posts.length') &&
      get(newPostNativeAd, 'length')
    ) {
      this.setState({
        sponsoredCardData: newPostNativeAd
      });
    }
  }

  getFeaturedStory(post) {
    return formatPostObject({
      props: this.props,
      post,
      imgSize: imageSizesLookup[1],
      allowTextOnly: true
    });
  }

  getSponsoredCardDataFromNativePixel() {
    const initialPageLoad = get(this.props, 'config.initialPageLoad');

    if (!initialPageLoad && canUseDOM) {
      // Local override test
      // Has list of IDs
      // window.fc_ads = {
      //   native: {
      //     homepageFeaturedTile: {
      //      article_ids: ['40523919', '40546561'],
      //      native_type: 'homepageFeaturedTile',
      //      card_type: 'Sponsored Story',
      //      sort: 'random'
      //     }
      //   }
      // };

      // Has campaign name, no id
      // window.fc_ads = {
      //   native: {
      //     homepageFeaturedTile: {
      //       clickthrough_url: null,
      //       article_ids: [''],
      //       campaign_name: 'shell_advertorial',
      //       native_type: 'homepageFeaturedTile',
      //       caption_text: null,
      //       card_type: 'Sponsored Story',
      //       sponsor: 'Sponsored Content',
      //       sort: 'random'
      //     }
      //   }
      // };

      // // Has text to override box
      // window.fc_ads = {
      //   native: {
      //     homepageFeaturedTile: {
      //       clickthrough_url:
      //         'https://retirementcommunity.fastcompany.com/episodes/101?utm_source=US_JH_BR_NV_FastCompany_RetirementCommunity_General_RR_CS_NA_DP_HP_CX_MI_VV_15s_030518_HPCustomNativeSingleMod_00;20828558;4577739;215726494;98772131',
      //       article_ids: [''],
      //       campaign_name: null,
      //       poster:
      //         'https://images.fastcompany.net/image/upload/w_386,ar_16:9,c_fill,f_auto,q_auto,fl_lossy/v1521640713/fc/JH_Homepage_Phase3_Ep1_w9tfp4.jpg',
      //       native_type: 'homepageFeaturedTile',
      //       card_type: 'Sponsored Story',
      //       caption_text:
      //         'Watch Episode 1: Pete Holmes & Jamie Lee Enter Retirement',
      //       sponsor: 'Sponsored Content',
      //       sort: 'recent'
      //     }
      //   }
      // };

      // Event Card
      // window.fc_ads = {
      //   native: {
      //     homepageFeaturedTile: {
      //       article_ids: [''],
      //       native_type: 'homepageFeaturedTile',
      //       card_type: 'Event',
      //       clickthrough_url:
      //         'http://events.fastcompany.com/fcny?utm_source=fastcompany&utm_medium=webmodule&utm_campaign=1003&utm_content=homepagesquare',
      //       caption_text: 'The Fast Company Innovation Festival',
      //       sponsor: 'October 23 – 27 / New York City',
      //       poster:
      //         'https://assets.fastcompany.com/image/upload/w_386,ar_16:9,c_fill,f_auto,q_auto,fl_lossy/v1507066903/fcweb/fcif-logo-16x9_sjpvnl.png',
      //       button_text: 'Register Now'
      //     }
      //   }
      // };

      const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');
      // console.log('nativeAdsData', nativeAdsData);
      if (!nativeAdsData) {
        return;
      }

      // Check if it's native_type === homepageFeaturedTile
      if (get(nativeAdsData, 'native_type') === 'homepageFeaturedTile') {
        if (
          !get(nativeAdsData, 'article_ids') &&
          !get(nativeAdsData, 'campaign_name') &&
          !get(nativeAdsData, 'clickthrough_url')
        ) {
          return;
        }

        this.props.dispatchPostNativeAd(
          nativeAdsData,
          get(this.props, 'config')
        );
      }
    }
  }

  getScrollingModule(scrollingModule) {
    const scrollingModuleTag = get(scrollingModule, 'tag', null);
    const newsStories = get(scrollingModule, 'posts', []).map(post =>
      formatPostObject({
        props: this.props,
        post,
        imgSize: imageSizesLookup.column,
        allowNoImage: true,
        deck: false
      })
    );
    const newsFeed = get(newsStories, 'length')
      ? { stories: newsStories, tag: scrollingModuleTag }
      : null;

    return newsFeed;
  }

  buildActiveSponsoredCardDataObject() {
    // console.log('build sponsor card');
    const featuredSponsoredCardType = get(
      this.state.sponsoredCardData,
      '[0].cardType'
    );

    if (!featuredSponsoredCardType) {
      // console.log('no sponsored card found');
      return [
        {
          newsletter: true,
          poster:
            'https://images.fastcompany.net/image/upload/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png',
          title: 'Fast Company Daily Newsletter',
          deck: 'Get our best stories delivered to your inbox.',
          noLazy: true
        }
      ];
    }

    // const parsedCardMetadata = JSON.parse(cardMetadata);
    const featuredSponsoredCardData = {
      Event() {
        const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');

        return [
          {
            id: '12345',
            topic: 'Events',
            title: get(nativeAdsData, 'caption_text'),
            link: get(nativeAdsData, 'clickthrough_url'),
            featured_image: {
              source: get(nativeAdsData, 'poster')
            },
            external: true,
            currentSite: get(this.props, 'config.site'),
            events: true,
            customEyebrowText: get(nativeAdsData, 'sponsor'),
            buttonText: get(nativeAdsData, 'button_text'),
            assetSizes: imageSizesLookup.bigFirstMobile,
            noLazy: true
          }
        ];
      },
      'Sponsored Story': () => this.state.sponsoredCardData
    };
    // figure out which card type it is, and send relevant metadata
    return featuredSponsoredCardData[featuredSponsoredCardType]();
  }

  renderSponsoredCard() {
    // console.log('render sponsored card');
    const initialPageLoad = get(this.props, 'config.initialPageLoad');

    if (!initialPageLoad && canUseDOM) {
      // console.log('should build sponsor card');
      const item = this.buildActiveSponsoredCardDataObject()[0];

      if (!get(item, 'newsletter')) {
        return (
          <Fragment>
            <Card
              metadata={item}
              noBottomBorder={false}
              config={get(this.props, 'config')}
              cardEvent={() => {
                trackGAEvent({
                  eventCategory: 'Engagement',
                  eventAction: 'FeaturedFeed:Pos-4:sponsored',
                  eventLabel: get(item, 'link')
                });
              }}
            />
          </Fragment>
        );
      }

      return (
        <div className="card card--default">
          <Fragment>
            <NewsletterSignup
              hideCheckBox={true}
              modifier="homepage"
              title={item.title || ''}
              deck={item.deck || ''}
              poster={
                item.poster ||
                'https://images.fastcompany.net/image/upload/w_772,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1488227009/fcweb/fj7ll7zhfiwfdlhgpe5g.png'
              }
              newsletters={[{ list: 'fastcompany', default: true }]}
            />
          </Fragment>
        </div>
      );
    }

    // server render nothing
    return '';
  }

  render() {
    const {
      featuredFeed,
      scrollingModule,
      social,
      config,
      combinedAdModel
    } = this.props;

    const featured = get(featuredFeed, 'featured', []);
    const topStories = get(featuredFeed, 'top', []);
    const totalTopStories = get(topStories, 'length');
    const hasSocial = !isEmpty(social) && 'row--social';

    return (
      <section className={`featured-feed featured-feed--${this.props.page} `}>
        <div className={`row ${hasSocial}`}>
          {hasSocial ? <Social {...social} /> : ''}
          <div className="featured-feed__stories">
            {featured.map((feature, index) => {
              const featuredStory = this.getFeaturedStory(feature);
              return (
                <Card
                  key={`feature-${index}`}
                  type="featured"
                  metadata={featuredStory}
                  config={config}
                  cardEvent={() => {
                    trackGAEvent({
                      eventCategory: 'Engagement',
                      eventAction: `FeaturedFeed:Pos-${index + 1}`,
                      eventLabel: get(featuredStory, 'link')
                    });
                  }}
                />
              );
            })}
          </div>
          <Scroll
            config={config}
            metadata={this.getScrollingModule(scrollingModule)}
            promoBanner={this.props.promoBanner}
            className="news-column"
            bottomAd={featured.length > 1}
            combinedAdModel={combinedAdModel}
          />
        </div>

        {get(this.props, 'featuredFeed.featured').length ? (
          <div className={`${this.props.page}-page__ff-ad-container`}>
            <Ad
              {...combinedAdModel}
              noLazyLoad
              pos="atf"
              name="flexiblebillboard_1"
            />
            <Ad
              {...combinedAdModel}
              noLazyLoad
              pos="atf"
              name="mobileparallax_1"
            />
          </div>
        ) : (
          ''
        )}

        {totalTopStories >= 2 ? (
          <Ad
            {...combinedAdModel}
            pos="atf"
            noBorder={true}
            slug={false}
            name="native_homepagefeature"
          />
        ) : (
          ''
        )}

        {totalTopStories >= 2 ? (
          <div className="row">
            {topStories.slice(0, 2).map((post, i, arr) => (
              <Card
                key={post.id}
                metadata={formatPostObject({
                  props: this.props,
                  post,
                  imgSize: imageSizesLookup[arr.length + 1],
                  allowTextOnly: true
                })}
                config={config}
                totalCards={arr.length + 1}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `FeaturedFeed:Pos-${i + 2}`,
                    eventLabel: get(post, 'link')
                  });
                }}
              />
            ))}
            {this.renderSponsoredCard()}
          </div>
        ) : null}

        {totalTopStories >= 4 ? (
          <div className="row">
            {topStories.slice(2, 4).map((post, i, arr) => (
              <Card
                key={post.id}
                metadata={formatPostObject({
                  props: this.props,
                  post,
                  imgSize: imageSizesLookup[arr.length],
                  allowTextOnly: true
                })}
                config={config}
                align="center"
                totalCards={arr.length}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `FeaturedFeed:Pos-${i + 5}`,
                    eventLabel: get(post, 'link')
                  });
                }}
              />
            ))}
          </div>
        ) : null}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    postpage: state.postpage,
    postNativeAd: get(state, 'postNativeAd.data', {}),
    adsLoaded: get(state, 'ads.data')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

FeatureFeed.defaultProps = {
  isPromoting: false,
  social: {},
  promoBanner: {},
  postNativeAd: {}
};

FeatureFeed.propTypes = {
  config: PropTypes.shape({}).isRequired,
  featuredFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  scrollingModule: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  postNativeAd: PropTypes.shape({}),
  promoBanner: PropTypes.shape({}),
  isPromoting: PropTypes.bool,
  social: PropTypes.shape({})
};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFeed);
